import { toNumber } from "lodash";

export const answerParser = (answers: any) => {
  let parsedAnswerSheet = {};
  if (answers) {
    Object.keys(answers).map((key) => {
      const asKey = toNumber(answers[key].problem);
      const asValue = toNumber(answers[key].options[0]);
      parsedAnswerSheet = { ...parsedAnswerSheet, [asKey]: asValue };
      return undefined;
    });
  }
  return parsedAnswerSheet;
};
